export default __webpack_public_path__ + "static/media/CosmusFitwell.76f59769.jpg";